var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .background {\n                fill: #173d65;\n                stroke: white;\n                stroke-miterlimit: 10;\n                stroke-width: 0.75px;\n            }\n            .cog {\n                fill: #fff;\n            } \n            width: '34px'\n            height: '34px'\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "background",
    cx: 12,
    cy: 12,
    r: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cog",
    d: "M18.63,14.14,17.08,13a5.2,5.2,0,0,0,.09-1h0a6.25,6.25,0,0,0-.1-1l1.56-1.18a.23.23,0,0,0,.06-.3L17.46,7.42a.24.24,0,0,0-.3-.09l-1.8.76a5.07,5.07,0,0,0-1.65-1l-.24-1.94a.24.24,0,0,0-.24-.2H10.77a.22.22,0,0,0-.23.2l-.25,1.94a5.07,5.07,0,0,0-1.65,1l-1.8-.76a.24.24,0,0,0-.3.09L5.31,9.56a.23.23,0,0,0,.06.3L6.93,11a5.16,5.16,0,0,0,0,1.92L5.37,14.14a.23.23,0,0,0-.06.3l1.23,2.14a.24.24,0,0,0,.3.09l1.8-.76a5.07,5.07,0,0,0,1.65,1l.25,1.94a.22.22,0,0,0,.23.2h2.46a.24.24,0,0,0,.24-.2l.24-1.94a5.07,5.07,0,0,0,1.65-1l1.8.76a.24.24,0,0,0,.3-.09l1.23-2.14A.23.23,0,0,0,18.63,14.14ZM12,14.57A2.57,2.57,0,1,1,14.57,12,2.57,2.57,0,0,1,12,14.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBlueCircle);
export default __webpack_public_path__ + "static/media/admin-blue-circle.83b8e7cacfa8370c774f86286def4379.svg";
export { ForwardRef as ReactComponent };